import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import './Home.css'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'slick-carousel';
import Profile2 from '../../Images/ProfileImages/Rutujimg.jpg'
import Profile1 from '../../Images/ProfileImages/Gauravimg.jpg'
import Profile3 from '../../Images/ProfileImages/Aniiimg.jpg'
import Profile4 from '../../Images/ProfileImages/Anuragimg.jpg'
import Profile5 from '../../Images/ProfileImages/Shashwatimg.jpg';
import Profile6 from '../../Images/ProfileImages/Himanshuimg.jpg';
import Whatsuplogo from '../../Images/HomeImages/Whatsupimg.png'
import Personimg from '../../Images/HomeImages/ProsonImg2.jpg'
import FirstSlider from '../../Components/FirstSlider'
import { Helmet } from 'react-helmet'
import Footer from '../../Components/Footer/Footer'
import VideoPlayer from '../../Components/Videoplay/VideoPlayer'
import { textDecoration } from '@chakra-ui/react';
import Loading from '../../Components/Loading/Loading';
import ImgLogo1 from '../../Images/HomeImages/window-cleaning.png'
import ImgLogo2 from '../../Images/HomeImages/calendar.png'
import Slider from "react-slick";
function Home() {

    const testimonials = [
        {
            name: "Gaurav Karewar",
            image: Profile1,
            text: "This service is amazing! My home has never been cleaner."
        },
        {
            name: "Rutuj Jain",
            image: Profile2,
            text: "Great job! The team was professional and thorough."
        },
        {
            name: "Anirudha Ahale",
            image: Profile3,
            text: "Highly recommend! They paid attention to every detail."
        },
        {
            name: "Anurag Hirukude",
            image: Profile4,
            text: "Excellent service! My home has never looked cleaner."
        },
        {
            name: "Shashwat Paratwar",
            image: Profile5,
            text: "The team was punctual and did an amazing job. Will hire again!"
        },
        {
            name: "Himanshu Sarode",
            image: Profile6,
            text: "Very impressed with the service. They went above and beyond!"
        }


    ];

    const testimonialSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };
    return (
        <>
            <div id="main">
                <Helmet>
                    <script src="https://kit.fontawesome.com/f75e97ac39.js"></script>
                    <script src="https://cdn.lordicon.com/lordicon.js"></script>
                </Helmet>


                <div id="slogan">
                    <h3>We Clean, So You Do Not Have To</h3>
                    <div id="background_img">
                        <VideoPlayer />
                    </div>
                </div>

                <div className="category_11">
                    <Link to='/sofa-cleaning' style={{ textDecoration: 'none' }}>
                        <div className="button_11">
                            <p>Sofa Cleaning</p>
                            <div className="homepageicons"><lord-icon src="https://cdn.lordicon.com/jrxatxqu.json" trigger="hover" style={{ width: '100%', height: '100%' }}></lord-icon></div>

                        </div>
                    </Link>
                    <Link to='/bathroom-cleaning' style={{ textDecoration: 'none' }}>
                        <div className="button_11">
                            <p>Bathroom Cleaning</p>
                            <div className="homepageicons">
                                <lord-icon src="https://cdn.lordicon.com/lwojkjmy.json" trigger="hover" stroke="bold" style={{ width: '100%', height: '100%' }}></lord-icon>
                            </div>
                        </div>
                    </Link>
                    <Link to='/Kitchen' style={{ textDecoration: 'none' }}>
                        <div className="button_11">
                            <p>Kitchen Cleaning</p>
                            <div className="homepageicons">
                                <lord-icon src="https://cdn.lordicon.com/sujekzdb.json" trigger="hover" style={{ width: '100%', height: '100%' }}></lord-icon>

                            </div>
                        </div>
                    </Link>
                    <Link to='/home-cleaning' style={{ textDecoration: 'none' }}>
                        <div className="button_11">
                            <p>Full Home Cleaning</p>
                            <div className='homepageicons'>
                                <lord-icon src="https://cdn.lordicon.com/epietrpn.json" trigger="hover" stroke="bold" style={{ width: '100%', height: '100%' }}></lord-icon>

                            </div>
                        </div>
                    </Link>
                </div>
                {/* <div className="aboutus-section">
                    <div className="aboutusimg">
                        <img src={Personimg} alt="" />
                    </div>
                    <div className="aboutus-descreption">
                        <div className="aboutus-des-subcontainer">
                            <p>Our Advantages</p>
                            <h2>What Makes Us Different</h2>
                            <div className="about-us-sub-container">
                                <ul>
                                    <li><div className="aboutus-content">
                                        <div className="aboutus-logo">
                                            <img src={ImgLogo1} alt="" />
                                        </div>
                                        <div className="aboutus-des">
                                            <h3>Professional Team</h3>
                                            <span>Our expert team provides thorough cleaning services for your entire home, sofas, kitchens, and more.</span>
                                        </div>
                                    </div></li>
                                    <li><div className="aboutus-content">
                                        <div className="aboutus-logo">
                                            <img src={ImgLogo2} alt="" />
                                        </div>
                                        <div className="aboutus-des" style={{ marginLeft: '10px' }}>
                                            <h3>Flexible Scheduling</h3>
                                            <span>Experience the convenience of flexible scheduling, allowing you to book cleaning services at a time that best suits your busy lifestyle.</span>
                                        </div>
                                    </div></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="our-services">
                    <p>Our Services</p>
                </div>
                <section className="slidercontainer">
                    <div className="slider-wrapper">
                        <FirstSlider />
                    </div>
                </section>

                {/* <div className="our-service-approach">
                    <p>How We Work</p>
                    <h2>Our Service Approach</h2>
                    <div className="process-explain">
                        <div className="process-explain-subdiv">
                            <div className="process-circle">01</div>
                            <div className="process-explain-des">Booking Online</div>
                        </div>
                        <div className="process-explain-subdiv">
                            <div className="process-circle">02</div>
                            <div className="process-explain-des">Cleaning Execution</div>
                        </div>
                        <div className="process-explain-subdiv">
                            <div className="process-circle">03</div>
                            <div className="process-explain-des">Quality Control</div>
                        </div>
                    </div>
                </div> */}
                <div className="our-services">
                    <p>Testimonials</p>
                </div>
                <section className="testimonial-section">
                    <div className="testimonial-slider-wrapper">
                        <Slider {...testimonialSettings}>
                            {testimonials.map((testimonial, index) => (
                                <div key={index} className="testimonial-slide-new">
                                    <div className="testimonial-content-new">
                                        <div className="testimonial-profile-new">
                                            <img src={testimonial.image} alt={testimonial.name} />
                                        </div>
                                        <h3>{testimonial.name}</h3>
                                        <p>{testimonial.text}</p>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </section>
                


            </div>
            <Footer />
        </>
    )
}

export default Home